import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import { getUser } from "../../../Utils/externalFunctions";
import TandaTerimaSubHeaderComponent from "./TandaTerimaSubHeaderComponent";
import { getItemEditStatusSuccessMsg } from "../../../Constant/Message";
import DATA_TYPE from "../../../Constant/DataType";
import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import { useNavigate } from "react-router-dom";
import { admins } from "../../../Constant";
import { useThemeContext } from "../../../Context/ThemeContext";
import ConfirmRemovalModal from "./ConfirmRemovalModal";
import getRincianTandaTerimaColumns from "../constants/getRincianTandaTerimaColumns";
import {
  deleteGroupDokumenTransaksi,
  getGroupTransaksi,
  updateGroupDokumenTransaksi,
  updateStatusDokumenTransaksi,
} from "../services";

toast.configure();

function RincianTandaTerimaModal({
  modalOpen,
  toggleModal,
  selectedTandaTerima,
  axiosInstance,
}) {
  const navigate = useNavigate();

  const [transaksiList, setTransaksiList] = useState([]);
  const [selectedListTransaksi, setSelectedListTransaksi] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const toggleDeleteModal = () => {
    if (selectedListTransaksi.length !== 0) {
      setDeleteModalOpen(!deleteModalOpen);
    }
  };
  console.log(transaksiList);

  const { themeContext } = useThemeContext();

  useEffect(() => {
    refreshTransaksi();
  }, [selectedTandaTerima]);

  const refreshTransaksi = async () => {
    if (selectedTandaTerima.group_transaksi.length !== 0) {
      const { data: groupTransaksiData } = await getGroupTransaksi(
        axiosInstance,
        selectedTandaTerima.group_transaksi
      );
      setTransaksiList(groupTransaksiData || []);
    } else {
      setTransaksiList([]);
    }
  };

  const handleCheckbox = (e) => {
    setSelectedListTransaksi(e.selectedRows);
  };

  const handleStatusChange = async (status_type) => {
    if (selectedListTransaksi.length !== 0) {
      const newListTransaksi = selectedListTransaksi.map((item) => ({
        ...item,
        status_dokumen: status_type,
      }));

      try {
        const resultList = newListTransaksi.map(
          async (transaksi, idx) =>
            await updateStatusDokumenTransaksi(
              axiosInstance,
              transaksi.id,
              transaksi
            ).then((res) => {
              if (idx === newListTransaksi.length - 1) refreshTransaksi();
              return res;
            })
        );

        if (allSuccess(resultList)) {
          toast.success(
            getItemEditStatusSuccessMsg(DATA_TYPE.DokumenTransaksi),
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: timeToast,
            }
          );
        } else {
          toast.error("Gagal mengupdate status dokumen transaksi", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: timeToast,
          });
        }
      } catch (e) {
        console.log(e.message);
        toast.error(e.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
      }
    }
  };

  const allSuccess = async (res) =>
    (await res.filter((item) => {
      const result = item
        .then((result) => (result?.status === 200 ? true : false))
        .catch((err) => console.log("err", err));
      return result;
    })) === (await res.length);

  const handleCetak = () => {
    selectedListTransaksi.map((item) => {
      window.open(
        `${process.env.PUBLIC_URL}/transaksi/document/${item.id}`,
        "_blank"
      );
    });
  };

  const handleDeleteListTransaksi = async () => {
    const transaksiIds = selectedListTransaksi.map((item) => item.id);

    const newTandaTerima = {
      ...selectedTandaTerima,
      group_transaksi: selectedTandaTerima.group_transaksi.filter(
        (id) => !transaksiIds.includes(id)
      ),
    };

    if (transaksiIds.length === selectedTandaTerima.group_transaksi.length) {
      deleteGroupDokumenTransaksi(
        axiosInstance,
        newTandaTerima.id,
        newTandaTerima
      ).then((res) => {
        navigate(`${process.env.PUBLIC_URL}/transaksi/tandaterima`);
      });
    } else {
      updateGroupDokumenTransaksi(
        axiosInstance,
        newTandaTerima.id,
        newTandaTerima
      ).then((res) => {
        navigate(`${process.env.PUBLIC_URL}/transaksi/tandaterima`);
      });
    }
  };

  return (
    <>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        size="xl"
        scrollable={true}
      >
        <ModalHeader toggle={toggleModal}>Group Dokumen Transaksi</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={5}></Col>
          </Row>
          <DataTable
            columns={getRincianTandaTerimaColumns({})}
            data={transaksiList}
            pagination
            selectableRowsHighlight
            highlightOnHover
            selectableRows
            onSelectedRowsChange={handleCheckbox}
            subHeader
            subHeaderComponent={
              admins.includes(getUser()) ? (
                <TandaTerimaSubHeaderComponent
                  handleStatusChange={handleStatusChange}
                  handleCetak={handleCetak}
                  toggleDeleteModal={toggleDeleteModal}
                />
              ) : null
            }
            subHeaderAlign="left"
            persistTableHead
            theme={themeContext}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>

        <ConfirmRemovalModal
          label={"Anda yakin ingin menghapus grup transaksi yang dipilih?"}
          isOpen={deleteModalOpen}
          toggle={toggleDeleteModal}
          // row={selectedListTransaksi}
          handleDelete={handleDeleteListTransaksi}
        />
      </Modal>
    </>
  );
}

export default RincianTandaTerimaModal;
